
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import type { PropType } from 'vue';
import { Book } from './types';
import StatisticsTrendsSale from './StatisticsTrendsSale';
import Accordion from '@/components/ui/accordion/Accordion.vue';

@Component({
  components: { Accordion, StatisticsTrendsSale }
})
export default class StatisticsTrendsBook extends Vue {
  @Prop({ type: Object as PropType<Book>, default: () => {} })
  book!: Book;

  accordionExpanded: boolean = false;

  renderContent() {
    this.accordionExpanded = !this.accordionExpanded;
  }
}
